import React from 'react'
import InfoBox from './Box'
import { InfoBoxWrapper } from './ElementsStyles'

export default function RoundInfo({ content }: any) {
  return (
    <InfoBoxWrapper>
      {content.map((box: any, id: number) => (
        <InfoBox key={id} content={box} />
      ))}
    </InfoBoxWrapper>
  )
}
